import script from "./CooperativePartner.vue?vue&type=script&setup=true&lang=js"
export * from "./CooperativePartner.vue?vue&type=script&setup=true&lang=js"

import "./CooperativePartner.vue?vue&type=style&index=0&id=65e04459&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65e04459"]])

export default __exports__